import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1d1d1b",
      light: "#9DFEAA",
      dark: "#dcb940",
      contrastText: "#dcb940",
    },
    secondary: {
      main: "#000000",
      light: "#545454",
      dark: "#000000",
      contrastText: "#ffffff",
    },
    background: {
      main: "#1d1d1b",
    },
  },
});

export default theme;